import { DiseaseForGridModel } from '../disease/diseaseForGridModel';
import { DrugInteractionContentModel } from './drugInteractionContentModel';

export class DrugToDiseaseInteractionAdminModel {
  public selectedIngredientId: number;
  public selectedIngredientName: string;
  public interactionTypeId: number;
  public consumerDecscription: string;
  public professionalDecscription: string;
  public disease: DiseaseForGridModel;
  public drugToDiseaseInteractionContent: Array<DrugInteractionContentModel>;
}